/** /history 요청 type value */
enum ACTIVITY_DETAIL_TYPE_CD {
  /** 적립 내역 */
  POINT_HISTORY_TYPE_ACCUMULATION = 'ACCUMULATE',
  /** 사용 내역 */
  POINT_HISTORY_TYPE_WITHDRAWAL = 'USE',
  /** 차감 내역 */
  POINT_HISTORY_TYPE_RECLAIMED = 'RECLAIMED',
}

export const ACTIVITY_DETAIL_TYPE_CD_MAP = {
  /** 적립 내역 */
  accumulation: ACTIVITY_DETAIL_TYPE_CD.POINT_HISTORY_TYPE_ACCUMULATION,
  /** 사용 내역 */
  usage: ACTIVITY_DETAIL_TYPE_CD.POINT_HISTORY_TYPE_WITHDRAWAL,
  /** 차감 내역 */
  reclaimed: ACTIVITY_DETAIL_TYPE_CD.POINT_HISTORY_TYPE_RECLAIMED,
};

export type HistoryTypeParamValue = keyof typeof ACTIVITY_DETAIL_TYPE_CD_MAP;
